import React from "react";
import { Form, Row } from "react-bootstrap";
import QboRegex from "./QboRegex";
type Props = {};
export const AdvancedOptions: React.SFC<Props> = ({}) => {
  const [enabled, setEnabled] = React.useState(false);
  return (
    <>
      <div className="ml-3">
        <Row>
          <Form.Check
            type="checkbox"
            checked={enabled}
            onChange={(e) => setEnabled(e.target.checked)}
          />
          Show advanced options
          {/* <PopoverHelp header="" id="verticalMergeHelp" placement="bottom">
          Merge multi-line fields into a single line. The merge is performed if
          the columns match the pattern specified here.
        </PopoverHelp> */}
        </Row>
      </div>
      {enabled && (
        <>
          <QboRegex />
        </>
      )}
    </>
  );
};
export default AdvancedOptions;
